module.exports = require("./lib/_stream_passthrough.js")



//////////////////
// WEBPACK FOOTER
// (webpack)/~/readable-stream/passthrough.js
// module id = 442
// module chunks = 1 4 5 6 8 9 10 12 14 15 21 22 24 27 28 58